import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../../ui/TextField";
import DataSelect  from "../../../../../../../ui/DataSelect";
import Checkbox from "../../../../../../../ui/Checkbox";
import {getOrganizations, getPrograms} from "../../../../../../../Study/Plan/store/actions";
import {getMasterClassFull} from "../../../store/actions";
import {updateMasterClassLogo, updateMasterClassDocument} from "../../../store/send";
import {deleteMasterClassLogo, deleteMasterClassDocument} from "../../../store/delete";
import {connect} from "react-redux";
import Progress from "../../../../../../../ui/Progress";
import InfoField from "../../../../../../../ui/InfoDrawer/components/InfoField";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import UploadDropzone from "../../../../../../../ui/FileIUpload/UploadDropzone";
import AttachmentCard from "../../../../../../../ui/AttachmentCard";

const defaultData = {
  name: "",
  description: "",
  organization : null,
  program : null,
  duration : false,
  capacity : null,
  date : "",
  timeStart: null
};

const defaultInfo = {
  count: 0,
  logo: null,
  status: null,
  document: null
}

const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 5
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  mainGrid:{
    marginTop: 8
  },
  block: {
    margin: "35px 0 15px 0"
  },
  label: {
    fontSize: 12
  },
  dropzoneWraper: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  },
  dropZoneButtonArea: {
    width: 75,
    height: 35,
    zIndex: 1000,
    position: "absolute",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },

  iconButton: {
    padding: 0,
    "&:hover": {
      backgroundColor: "transparent"
    }
  }
});

const MainInfo = ({ mcId,
                    disabled = false,
                    onFormChange,
                    classes,
                    editmode,
                    getOrganizations,
                    organizations,
                    getPrograms,
                    programs,
                    masterClassFullInfo,
                    getMasterClassFull,
  updateMasterClassLogo,
  updateMasterClassDocument,
  deleteMasterClassLogo,
  deleteMasterClassDocument,
                    isFetchingFullMasterClass,}) => {
  const [data, setData] = React.useState(defaultData);
  const [info, setInfo] = React.useState(defaultInfo);
  const { name, description, organization, program, duration, capacity, date, timeStart } = data;

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  React.useEffect(() => {
    getOrganizations();
  }, []);

  React.useEffect(() => {
    if (organization && organization > -1) {
      getPrograms(organization);
    }
  }, [organization]);

  React.useEffect(() => {
    mcId && getMasterClassFull(mcId);
  },[mcId]);

  React.useEffect(() => {
    if (masterClassFullInfo) {
      masterClassFullInfo.data && setData(masterClassFullInfo.data);
      masterClassFullInfo.info && setInfo(masterClassFullInfo.info);
    }
  },[masterClassFullInfo]);

  const UploadLogo = files => {
    if (mcId && mcId > -1 && files.length > 0) {
      updateMasterClassLogo(mcId, files[0]);
    }
  };

  const UploadDocument = files => {
    if (mcId && mcId > -1 && files.length > 0) {
      updateMasterClassDocument(mcId, files[0]);
    }
  }

  return (
    <div className={classes.root}>
      <Typography className={classes.heading}>Основные параметры</Typography>
      {data ?
      <Grid container spacing={1} className={classes.mainGrid}>
        <Grid item xs={12}>
          <TextField
            required
            value={name || ""}
            onChange={e => onChange("name", e.target.value)}
            label="Наименование"
            disabled={disabled || !editmode}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <TextField
            required
            value={date}
            onChange={e => onChange("date", e.target.value)}
            label="Дата"
            format="dd.MM.yyyy"
            type="date"
            disabled={disabled || !editmode}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <TextField
            required
            value={timeStart || ""}
            onChange={e => onChange("timeStart", e.target.value)}
            label="Начало занятий"
            disabled={disabled || !editmode}
            type="time"
            inputProps={{
              step: 300, // 5 min
            }}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <TextField
            value={capacity || ""}
            onChange={e => onChange("capacity", e.target.value)}
            label="Макс. кол-во"
            disabled={disabled || !editmode}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <TextField
            required
            value={duration || ""}
            onChange={e => onChange("duration", e.target.value)}
            label="Продолжительность, ч."
            disabled={disabled || !editmode}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          {organizations && <DataSelect
            value={organization}
            onChange={value => onChange("organization", value.id)}
            label="Подрядчик"
            dataSource={organizations}
            disabled={disabled || !editmode}
            required
          />}
        </Grid>
        <Grid item xs={12} md={6}>
          {programs && <DataSelect
            value={program}
            onChange={value => onChange("program", value._key)}
            label="Программа/Модуль"
            dataSource={programs}
            disabled={disabled || !editmode}
            keyField="_key"
            required
          />}
        </Grid>
        <Grid item xs={12}>
          <TextField
            value={description || ""}
            onChange={e => onChange("description", e.target.value)}
            label="Описание"
            disabled={disabled || !editmode}
          />
        </Grid>
      </Grid>
      :  <Progress />}

      <br/>
      <Typography className={classes.heading}>Загруженные файлы</Typography>
      {info ?
      <Grid container spacing={1} className={classes.mainGrid}>
        <Grid item xs={6}>
          <div>
            <InfoField name="Изображение карточки" />
            <div className={classes.dropzoneWraper}>
              <div className={classes.dropZoneButtonArea}>
                <Tooltip title="Удалить" placement="top">
                  <IconButton
                    classes={{ root: classes.iconButton }}
                    onClick={() => deleteMasterClassLogo(mcId)}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </div>
              <UploadDropzone
                type="card"
                fileId={info.logo}
                accept={[".jpg", ".jpeg", ".png"]}
                onDrop={image => {
                  UploadLogo(image);
                }}
              />
            </div>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div>
            <InfoField name="Файл программы мастер-класса" />
            <div>
              {info.document ? (
                <AttachmentCard
                  id={info.document.fileId}
                  mimeType={info.document.mimeType}
                  fileName={info.document.fileName}
                  fileSize={info.document.size}
                  fileLink={info.document.fileId}
                  download
                  removeDocument={() => deleteMasterClassDocument(mcId)}
                />
              ) : (
                <UploadDropzone
                  onDrop={doc => {
                    UploadDocument(doc);
                  }}
                  accept={[".pdf"]}
                  maxSize={2000000}
                />
              )}
            </div>
          </div>
        </Grid>
      </Grid> : <Progress/>}

    </div>
  );
};

const mapStateToProps = state => ({
  isFetchingOrganizations: state.studyPlan.isFetchingOrganizations,
  organizations: state.studyPlan.organizations,
  isFetchingPrograms: state.studyPlan.isFetchingPrograms,
  programs: state.studyPlan.programs,
  masterClassFullInfo: state.masterClasses.masterClassFullInfo,
  isFetchingFullMasterClass: state.masterClasses.isFetchingFullMasterClass
});

const mapDispatchToProps = dispatch => ({
  getOrganizations: () => dispatch(getOrganizations()),
  getPrograms: (orgId) => dispatch(getPrograms(orgId)),
  getMasterClassFull: (id) => dispatch(getMasterClassFull(id)),
  updateMasterClassLogo: (id, logo) => dispatch(updateMasterClassLogo(id, logo)),
  updateMasterClassDocument: (id, file) => dispatch(updateMasterClassDocument(id, file)),
  deleteMasterClassLogo: (id) => dispatch(deleteMasterClassLogo(id)),
  deleteMasterClassDocument: (id) => dispatch(deleteMasterClassDocument(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MainInfo));
